angular.module('app.controllers').controller 'ApplicationCtrl', [
  '$scope', '$route', '$rootScope', '$sce', '$interval', '$cookies', 'UI', '$location', '$timeout', 'APIData', 'APIForm', 'APIFile', '$http', 'APIExhibitor', 'APIEvent'
].append (self, $route, root, $sce, $interval, $cookies, UI, $location, $timeout, APIData, APIForm, APIFile, $http, APIExhibitor, APIEvent) ->
  
  params = $location.search()

  self.trustAsResourceUrl = $sce.trustAsResourceUrl
  
  self.trustAsHtml = (string) -> return $sce.trustAsHtml(string)
  
  self.fake = 
    product_areas: []
    logo: null
    check1: false
    check2: false
    check3: false

  if angular.isDefined(params.hash) 
    if parseInt(params.hash) is 38110
      self.token = "Hf4p55mvz_1DLsxs2mBC" 
      self.exhibitor_id = 38110 
    else 
      decode = atob(params.hash)?.split("|") || []
      self.token = decode[2] || null
      self.exhibitor_id = decode[1] || null

    if self.token? && self.exhibitor_id?
      APIData.get {exhibitor_id: self.exhibitor_id, auth_token: self.token}, (data) ->
        self.data = if Object.values(data).length > 2 then data else null
        self.data.area = parseInt(self.data.area) if self.data?.area
        self.fake.product_areas = self.data?.product_areas?.split(",").filter(Boolean) || []
      , (response) ->
        UI.notify false, response.data.error
  
  self.saveForm = (slug, form) ->
    self[slug] = form  


  self.formProccess = false
  self.formSuccess  = false

  #
  # Contact Modal
  #

  self.hideContactModal = () ->
    self.formProccess = false
    self.formSuccess  = false

    self.cForm.$setPristine()
    self.cForm.$setUntouched()


  self.showContactModal = () ->
    self.formProccess = false    

    self.fake.check1 = false
    self.fake.check2 = false
    self.fake.check3 = false

    self.cdata = 
      company: ""
      first_name: ""
      last_name: ""
      email: ""
      phone: ""
      message: ""

  self.contactModalEl = document.getElementById('modalContacts')

  if self.contactModalEl
    self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl)
  
    self.contactModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.hideContactModal()
      self.$applyAsync()
    )

    self.contactModalEl.addEventListener('shown.bs.modal', (event) ->
      self.showContactModal()
      self.$applyAsync()
    )

  self.contact = () ->    
    self.formProccess = true

    (new APIForm self.cdata).$save {}, (data) ->
      if data.success
        self.showContactModal()
        self.formSuccess = data.success

      self.cForm.$setPristine()
      self.cForm.$setUntouched()

    , (response) ->
      self.formProccess = false
      UI.notify false, response.data.error

  #
  # Registration Modal
  #

  self.areasChanged = () ->
    self.data.product_areas = self.fake.product_areas.join(",")

  self.step = 1
  self.setStep = (next = true) ->
    return self.register() if self.step == 3 && next
    return false if self.step == 1 && !next
    self.step++ if next
    self.step-- unless next

  self.hideRegModal = () ->
    self.formProccess = false
    self.formSuccess  = false

    self.rForm1.$setPristine()
    self.rForm1.$setUntouched()

    self.rForm2.$setPristine()
    self.rForm2.$setUntouched()

    self.rForm3.$setPristine()
    self.rForm3.$setUntouched()
    
    return

  self.showRegModal = () ->
    self.formProccess = false
    self.step         = if self.data.registered && parseInt(params?.hash) != 38110 then 5 else 1
    return

  self.regModalEl = document.getElementById('modalReg')

  if self.regModalEl
    self.regModal = bootstrap.Modal.getOrCreateInstance(self.regModalEl)
  
    self.regModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.hideRegModal()
      self.$applyAsync()
    )

    self.regModalEl.addEventListener('show.bs.modal', (event) ->
      return event.preventDefault() unless self.data?
      self.showRegModal()
      self.$applyAsync()
    )

  self.register = () ->
    self.formProccess     = true
    self.data.registered  = true
    
    if self.fake.logo         
      fd = new FormData()
      fd.append 'logofile', true
      fd.append 'file', self.fake.logo

      $http.post "api.php?path=/exhibitor_data/upload&_private=true&auth_token=" + self.token, fd,
        transformRequest: angular.identity
        headers: 
          'Content-Type': undefined
      .then (response) ->
        self.data.logo = response.data

        self.data.$update {exhibitor_id: self.exhibitor_id, auth_token: self.token}, (data) ->
          self.formProccess = false
          self.formSuccess  = true 
          (new APIFile data).$save {}

          APIEvent.get {auth_token: self.token, _entry: 'ticket', role: 's'}, (data) ->
            (new APIExhibitor {is_visible: true}).$update {ticket_id: data.service_tickets.exhibitor?.ticket_id || null, _entry: 'visibility'}

          self.step = 4
        , (response) ->
          self.formProccess = false
          UI.notify false, response.data.error

      , (response) ->
        self.formProccess = false
        UI.notify false, response.data.error
    else
      self.data.$update {exhibitor_id: self.exhibitor_id, auth_token: self.token}, (data) ->
        self.formProccess = false
        self.formSuccess  = true 
        (new APIFile data).$save {}

        APIEvent.get {auth_token: self.token, _entry: 'ticket', role: 's'}, (data) ->
          (new APIExhibitor {is_visible: true}).$update {ticket_id: data.service_tickets.exhibitor?.ticket_id || null, _entry: 'visibility'}

        self.step = 4
      , (response) ->
        self.formProccess = false
        UI.notify false, response.data.error


    
    